/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { formatTime } from '../../../../../../javascript/time_formatting';
import * as Utilities from '../../utilities';
import { QuantitySelect } from './quantity_select.jsx';
import { CurrencyInput } from '../../../react/currency_input.jsx';

export class TicketClassQuantityRow extends React.Component {
        constructor(...args) {
          super(...args);
          this.onItemPriceChange = this.onItemPriceChange.bind(this);
this.onQuantityChange = this.onQuantityChange.bind(this);
        }

        static initClass() {
          this.propTypes = {
            id: PropTypes.number,
            // Callback for a quantity change
            onQuantityChange: PropTypes.func,
            // Callback for donation amount change
            onItemPriceChange: PropTypes.func,
            // Donation amount
            donationAmount: PropTypes.number
          };
        }

        onItemPriceChange(event, cents) {
          return (typeof this.props.onItemPriceChange === 'function' ? this.props.onItemPriceChange(this.props.id, cents) : undefined);
        }

        render() {
          // +true+ if there no quantity available, +false+ otherwise
          let max_purchase; let min_purchase;
          const sold_out = this.props.availability === 0;
          const available_for_sale = !sold_out && this.props.available_now;

          const error_message = (() => { switch (this.props.error) {
            case 'sold_out':
              return "This ticket is sold out";
            case 'invalid_quantity':
              return "You cannot buy that many tickets";
            case 'invalid_price':
              if ((this.props.min_price > 0) && (this.props.max_price > 0)) {
                return `You must enter a price between ${ 
                  Utilities.formatCurrency(this.props.min_price, this.props.currency) 
                  } and ${ 
                  Utilities.formatCurrency(this.props.max_price, this.props.currency)}`;
              } else if ((this.props.min_price === 0) && (this.props.max_price > 0)) {
                return `You must enter a price less than ${Utilities.formatCurrency(this.props.max_price, this.props.currency)}`;
              } 
                return `You must enter a price greater than ${Utilities.formatCurrency(this.props.min_price, this.props.currency)}`;
              
            default:
              return null;
          } })();

          if (sold_out) {
            max_purchase = (min_purchase = 0);
          } else {
            // Build the select options
            max_purchase = this.props.availability;
            // An availability of -1 means there is no limit on the amount of tickets available
            if (max_purchase === -1) { max_purchase = 20; }

            // Don't allow less than the purcahse minimum number of tickets
            min_purchase = _.max([1, this.props.purchase_minimum]);
            // Limit to 20 tickets at a time
            max_purchase = _.min([max_purchase, this.props.purchase_limit || 20]);
            // But limit donation tickets to quantity of one, regardless of other settings
            if (this.props.donation) { max_purchase = _.min([max_purchase, 1]); }
          }

          const price = this.props.price === 0 ? "Free" : Utilities.formatCurrency(this.props.price, this.props.currency);

          return <div className="ticket_class">
            <label className="ticket_name" htmlFor={`${this.props.id  }_instance_quantity_select`}>{`${this.props.name  } quantity`}</label>
            <div className="ticket_info">
              <div className="ticket_text">
                <p>{this.props.availability == 0 ? 'SOLD OUT' : !this.props.donation && price}</p>
                {this.props.description && (<span className="ticket_dexcription">{this.props.description}</span>)}
              </div>
              <span className="ticket_price">
                {available_for_sale && this.props.donation && <div className="donation_amount">
                  <CurrencyInput currency={this.props.currency}
                                value={this.props.donationAmount}
                                placeholderValue={this.props.min_price}
                                onChange={this.onItemPriceChange} />
                </div>}

                {available_for_sale && !this.props.donation && <div className="ticket_quantity">
                  <QuantitySelect min={min_purchase}
                                  max={max_purchase}
                                  value={this.props.selectedQuantity}
                                  onChange={this.onQuantityChange}
                                  id={`${this.props.id  }_instance_quantity_select`}
                                  aria-label={`${this.props.name  } quantity`} />
                </div>}

                {this.props.not_yet_available && <p className="ticket_notes">Available Starting {this._formatDateTime(this.props.availability_start)}</p>}
                {this.props.no_longer_available && <p className="ticket_notes">Sales Ended {this._formatDateTime(this.props.availability_finish)}</p>}
                {this.props.available_now && this.props.availability_finish && <p className="ticket_notes">On Sale Until {this._formatDateTime(this.props.availability_finish)}</p>}
              </span>
            </div>
            {error_message && <p className="error_marker" role="alert">{error_message}</p>}
          </div>;
        }

        onQuantityChange(event) {
          return (typeof this.props.onQuantityChange === 'function' ? this.props.onQuantityChange(this.props.id, event.target.value) : undefined);
        }

        _formatDateTime(time) {
          const date = new Date(time);
          return formatTime(date, null, 'detailed');
        }
      }
TicketClassQuantityRow.initClass();